const appName = process.env.VUE_APP_NAME;
const appUrl = process.env.VUE_APP_URL;
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
const socketBaseUrl = process.env.VUE_APP_SOCKET_URL;
const payGateCheckoutUrl = process.env.VUE_APP_PAYGATE_CHECKOUT_URL;
const paygateBatchUrl = process.env.VUE_APP_PAYGATE_BATCH_URL;
const multiCompany = process.env.VUE_APP_MULTI_COMPANY;
const initiatePesaflowBatchPayment = process.env.VUE_APP_INIATE_PESAFLOW_BATCH;

export {
  appName,
  appUrl,
  apiBaseUrl,
  socketBaseUrl,
  payGateCheckoutUrl,
  paygateBatchUrl,
  multiCompany,
  initiatePesaflowBatchPayment,
};
